var _style, _defs, _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoExportarDatos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.41 28",
    style: {
      enableBackground: "new 0 0 31.41 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000054958149851643276390000011168892129251855548_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#7367F0;}\n\t.st2{fill:#7367F0;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 31.41,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173132414931039193920000017875810229127483552_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1929",
    style: {
      clipPath: "url(#SVGID_00000173132414931039193920000017875810229127483552_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3575",
    className: "st1",
    d: "M16.43,10.92c-0.4-0.41-1.06-0.41-1.47-0.01c-0.01,0.01-0.01,0.01-0.02,0.02l-4.91,5 c-0.33,0.33-0.33,0.87,0,1.2s0.87,0.33,1.2,0l3.34-3.35c0.16-0.16,0.3-0.11,0.3,0.13v9.23c0,0.47,0.38,0.85,0.85,0.85 s0.85-0.38,0.85-0.85v-9.23c0-0.23,0.13-0.29,0.3-0.13l3.34,3.35c0.33,0.33,0.87,0.33,1.2,0s0.33-0.87,0-1.2L16.43,10.92z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1316",
    x: 0.85,
    y: 6.79,
    className: "st2",
    width: 29.7,
    height: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3576",
    className: "st2",
    d: "M1.7,0h6.23c0.75,0.03,1.46,0.29,2.04,0.76l1.36,1.18c0.27,0.2,0.59,0.32,0.93,0.35h17.46 c0.94,0,1.7,0.76,1.7,1.7c0,0,0,0,0,0L31.39,26.3c0,0.94-0.76,1.7-1.69,1.7h-28C0.76,28,0,27.24,0,26.31V1.69C0,0.76,0.76,0,1.7,0 z M12.26,3.99c-0.75-0.03-1.46-0.29-2.04-0.76L8.86,2.04C8.59,1.85,8.27,1.73,7.93,1.7H1.7v24.6h28l0.02-22.31L12.26,3.99 L12.26,3.99z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoExportarDatos);
export default __webpack_public_path__ + "static/media/icono-exportar-datos.a0803735330c17ee6c68697fa50265ac.svg";
export { ForwardRef as ReactComponent };